import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TEMPLATES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'

const workflowTemplates = {
  namespaced: true,
  state: buildInitialState({
    workflowTemplateList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowTemplatesWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getWorkflowTemplates', { ...rootGetters['workflowTemplateFilters/getSearchObject'] })
    },
    getWorkflowTemplates ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading templates, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_TEMPLATES, parameters: filters })
        .then(json => json.data)
        .then(templates => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTemplates', templates)
          return templates
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load templates')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getWorkflowTemplatesWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getWorkflowTemplatesPaginated', {
        ...rootGetters['workflowTemplateFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getWorkflowTemplatesPaginated: createPaginatedGetAction(PATH_WORKFLOW_TEMPLATES, 'setPaginatedWorkflowTemplates', 'Unable to load templates')
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowTemplates (state, templates) {
      state.workflowTemplateList = templates
    },
    setPaginatedWorkflowTemplates (state, { result, totalRecords }) {
      state.workflowTemplateList = result
      state.totalRecords = totalRecords
    }
  }
}

export default workflowTemplates
